import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { FloorPlanLayout } from './FloorPlan/components/FloorPlanLayout';
import { FloorPlanContainer } from './FloorPlan/FloorPlanContainer';
import { Filters } from '../Filters';
import { filtersMapper } from '../../../../mappers';
import { useFloorPlanFilters } from '../../../../hooks/useFloorPlanFilters';
import { FlatsList } from '../FlatsList';
import { FlatPlan } from '../FlatPlan';
import { SimilarFlatsList } from '../SimilarFlatsList';
import { TrackingContext } from '../../../../tracking/TrackingContext';
import { jsx as _jsx } from "react/jsx-runtime";
export var FloorPlan = function FloorPlan(_ref) {
  var floorPlan = _ref.floorPlan,
    isError = _ref.isError,
    isLoading = _ref.isLoading,
    loadPlan = _ref.loadPlan;
  var _React$useContext = React.useContext(TrackingContext),
    onPolygonClick = _React$useContext.onPolygonClick;
  var _React$useState = React.useState(null),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    flatPlanId = _React$useState2[0],
    setFlatPlanId = _React$useState2[1];
  var _React$useState3 = React.useState(null),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    hoveredFlatPlanId = _React$useState4[0],
    setHoveredFlatPlanId = _React$useState4[1];
  var filters = React.useMemo(function () {
    return filtersMapper(floorPlan);
  }, [floorPlan]);
  var flatsCount = React.useMemo(function () {
    return floorPlan !== null && floorPlan !== void 0 && floorPlan.flats ? floorPlan === null || floorPlan === void 0 ? void 0 : floorPlan.flats.length : 0;
  }, [floorPlan]);
  var flats = React.useMemo(function () {
    return floorPlan !== null && floorPlan !== void 0 && floorPlan.flats ? floorPlan.flats : [];
  }, [floorPlan]);
  var floors = React.useMemo(function () {
    return (floorPlan === null || floorPlan === void 0 ? void 0 : floorPlan.floors) || [];
  }, [floorPlan]);
  var floorNumber = React.useMemo(function () {
    return (floorPlan === null || floorPlan === void 0 ? void 0 : floorPlan.floorNumber) || '';
  }, [floorPlan]);
  var flatCountLabel = React.useMemo(function () {
    return (floorPlan === null || floorPlan === void 0 ? void 0 : floorPlan.flatCountLabel) || '';
  }, [floorPlan]);
  var flat = React.useMemo(function () {
    return flats.find(function (flat) {
      return flat.id === flatPlanId;
    });
  }, [flatPlanId]);
  var activeFlats = flats.filter(function (flat) {
    return !flat.booked;
  }) || [];
  var onFlatHover = React.useCallback(function (id) {
    setHoveredFlatPlanId(id);
  }, []);
  var onOpen = React.useCallback(function (id) {
    setFlatPlanId(id);
    onPolygonClick(id);
  }, []);
  var onClose = React.useCallback(function () {
    setFlatPlanId(null);
  }, []);
  var filtersProps = useFloorPlanFilters({
    loadPlan: loadPlan,
    filters: filters,
    floors: floors
  });
  return flat ? /*#__PURE__*/_jsx(FlatPlan, {
    flat: flat,
    onClose: onClose,
    rightPanel: /*#__PURE__*/_jsx(SimilarFlatsList, {
      offerId: flat.id
    })
  }) : /*#__PURE__*/_jsx(FloorPlanLayout, {
    plan: /*#__PURE__*/_jsx(FloorPlanContainer, {
      hoveredFlatPlanId: hoveredFlatPlanId,
      flats: activeFlats,
      flatsCount: flatsCount,
      isError: isError,
      isLoading: isLoading,
      isPlanAccurate: floorPlan === null || floorPlan === void 0 ? void 0 : floorPlan.isPlanAccurate,
      floorPlanUrl: floorPlan === null || floorPlan === void 0 ? void 0 : floorPlan.floorPlanUrl,
      onFlatOpen: onOpen,
      onFlatHover: onFlatHover
    }),
    rightPanel: /*#__PURE__*/_jsx(FlatsList, {
      floorNumber: "".concat(floorNumber, " \u044D\u0442\u0430\u0436"),
      flatCountLabel: flatCountLabel,
      hoveredFlatPlanId: hoveredFlatPlanId,
      onFlatHover: onFlatHover,
      flats: flats
    }),
    filters: /*#__PURE__*/_jsx(Filters, _objectSpread({}, filtersProps))
  });
};